<div #uebersichtHeader>
  <div class="row bg-uebersicht-header px-4x" id="main-header">
    <div class="infobox d-flex col-md-6 col-sm-6">
      <em class="icon icon-information"></em>
      <p>{{ 'FRAGEBOEGEN_APP.UEBERSICHT.INFOBOX' | translate }}</p>
    </div>
    <div class="frageboegen-search d-flex col-md-6 col-sm-6 pr-0">
      <input
        #searchInput
        (input)="search()"
        (keyup.enter)="search(true)"
        [(ngModel)]="searchValue"
        aria-label="Search"
        class="search"
        placeholder="{{ 'FRAGEBOEGEN_APP.UEBERSICHT.SUCHE' | translate }}"
        type="search">
      <button (click)="search(true)" *ngIf="!activeSearch" class="search-icon" tabindex="-1"></button>
      <button (click)="deleteSearch()" *ngIf="activeSearch" class="delete-icon" tabindex="-1"></button>
    </div>
  </div>
  <div class="row bg-uebersicht-header">
    <frageboegen-tabbar (selected)="onTabSelected($event)">
      <frageboegen-tab
        [active]="unsentTab.active"
        [category]="unsentTab.category"
        [count]="unsentTab.count"
        [name]="unsentTab.name"
        [title]="unsentTab.title">
        <frageboegen-data-table
          (deleteItem)="deleteItem($event)"
          [activeSearch]="activeSearch"
          [defaultSortColumnId]="unsentTab.defaultSortColumn"
          [inputData]="unsentDocuments"
          [searchValue]="searchValue"
          [selectedDocumentId]="selectedDocumentId"
          [tableHeaders]="unsentTableHeaders"
          [tableId]="unsentTab.name">
        </frageboegen-data-table>
      </frageboegen-tab>
      <frageboegen-tab
        [active]="sentTab.active"
        [category]="sentTab.category"
        [count]="sentTab.count"
        [name]="sentTab.name"
        [title]="sentTab.title">
        <frageboegen-data-table
          [activeSearch]="activeSearch"
          [defaultSortColumnId]="sentTab.defaultSortColumn"
          [inputData]="sentDocuments"
          [searchValue]="searchValue"
          [sentDocumentId]="sentDocumentId"
          [tableHeaders]="sentTableHeaders"
          [tableId]="sentTab.name">
        </frageboegen-data-table>
      </frageboegen-tab>
    </frageboegen-tabbar>
  </div>
</div>
<common-ui-footer></common-ui-footer>
